import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "./components";
import { LanguageContextProvider } from "./context";
import { FilterProvider } from "./context/FilterContext";
import { FilterProvider as ActiveFilterProvider } from "./context/ActiveFiltersContext";
import "./index.css";
import configStore from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import router from "./routes";
import client from "./api/apollo/apolloClient";
import { ApolloProvider } from "@apollo/client";
import { SWRConfig } from "swr";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

const RESIZE_OBSERVER_LOOP_ERROR = "ResizeObserver loop completed with undelivered notifications.";

function suppressResizeObserverError(event) {
  if (event?.message === RESIZE_OBSERVER_LOOP_ERROR) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
  }
}

window.addEventListener("error", suppressResizeObserverError);

// ..
AOS.init();

// // Enregistrement du Service Worker FCM
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Service Worker FCM enregistré :", registration);
//     })
//     .catch((err) => {
//       console.error("Erreur enregistrement Service Worker FCM :", err);
//     });
// }

const store = configStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ApolloProvider client={client}>
        <SWRConfig
          value={{
            provider: () => new Map(),
            isVisible: () => true,
            initFocus(callback) {
              const onFocusChange = () => {
                if (document.visibilityState === "visible") {
                  callback();
                }
              };
              const onWindowFocus = () => {
                callback();
              };
              // Écouter les changements de visibilité de la page
              document.addEventListener("visibilitychange", onFocusChange);
              // Écouter le focus de la fenêtre
              window.addEventListener("focus", onWindowFocus);
              // Fonction de nettoyage
              return () => {
                document.removeEventListener("visibilitychange", onFocusChange);
                window.removeEventListener("focus", onWindowFocus);
              };
            },
            // Configuration additionnelle pour optimiser les performances
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
            refreshInterval: 0, // Pas de refresh automatique
            dedupingInterval: 2000, // Éviter les requêtes dupliquées pendant 2s
            errorRetryCount: 3,
            errorRetryInterval: 5000,
            // Fonction fetcher par défaut si nécessaire
            fetcher: (resource, init) =>
              fetch(resource, init).then((res) => res.json()),
          }}
        >
          <Provider store={store}>
            <LanguageContextProvider>
              <FilterProvider>
                <ActiveFilterProvider>
                  <Suspense fallback={<Loader />}>
                    <RouterProvider router={router} />
                  </Suspense>
                  <ToastContainer
                    position="bottom-left"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                  />
                </ActiveFilterProvider>
              </FilterProvider>
            </LanguageContextProvider>
          </Provider>
        </SWRConfig>
      </ApolloProvider>
    </MuiPickersUtilsProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
